import { createContext } from 'react';

/** Separate file from Authcontext.js — Windows paths are case-insensitive. */
export const AuthContext = createContext(null);
